import type { SelectOption } from '@skupreme/shared/ui';
import { US_ZIP_REGEX } from '@utility/validations';
import { flagImages } from '../legacy-bridge';

/** A marketplace region as the region dropdown hook returns it. */
export type Region = { id: string; text: string; name: string; flag: string };

/** A country's flag to lead an option with; the world flag for an unknown code. */
export function flagIcon(countryCode: string | undefined) {
  const flag = flagImages[countryCode?.toUpperCase() ?? ''] ?? flagImages.WW;
  return flag ? (
    <img
      src={flag}
      alt=""
      className="sk:h-3 sk:w-4 sk:rounded-xs sk:object-cover"
    />
  ) : undefined;
}

/** Regions as select options, each led by its flag. */
export function toCountryOptions(regions: Region[]): SelectOption[] {
  return regions.map(region => ({
    value: region.id,
    label: region.text,
    leading: flagIcon(region.name),
  }));
}

/** Only a US ZIP has a shape to check. */
export function isZipValid(
  regions: Region[],
  regionId: string | undefined,
  zip: string | undefined,
) {
  const country = regions.find(region => region.id === regionId);
  if (country?.name?.toLowerCase() === 'us' && zip) {
    return US_ZIP_REGEX.test(zip);
  }
  return true;
}
